import React from "react";
import { PreviewContainer } from "./common";
import useApiImage from "../useApiImage";
import {
  getActiveTableFileTypeConfig,
  getSpecificFileTypeByFilename,
} from "../../../utils/activeTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../constants";

const defaultHeight = 200;

export default function ActiveTablePreviewImage({
  existingFile,
  columnType,
  isFullScreen,
}) {
  return columnType === "api-image" ? (
    <Image existingImage={existingFile} isFullScreen={isFullScreen} />
  ) : (
    <File
      columnType={
        getSpecificFileTypeByFilename(existingFile)?.apiType ?? columnType
      }
    />
  );
}

function Image({ existingImage, isFullScreen }) {
  const { image } = useApiImage(existingImage);

  return (
    <PreviewContainer
      style={{
        backgroundImage: `url(${image?.data})`,
        height: isFullScreen ? "100%" : defaultHeight,
        width: "100%",
      }}
    />
  );
}

function File({ columnType }) {
  const config = getActiveTableFileTypeConfig(columnType);

  return (
    <PreviewContainer>
      <FontAwesomeIcon
        icon={config.solid_icon}
        style={{ width: "100%", height: "100%" }}
        color={colors.fileIcon}
      />
    </PreviewContainer>
  );
}
